/**
 * The portal opened by Login as Store (EP01-S16).
 *
 * The Admin Console opens `/#imp=<token>`. On load the token moves from the
 * fragment into this tab's session storage and the fragment is removed from the
 * address, so it is not in the history, not copied with the URL and not
 * visible over a shoulder. From then on every request in this tab carries the
 * session's token instead of a sign-in: the tab *is* the session, and closing
 * it or ending the session is all there is to leaving.
 *
 * Session storage, not local storage: one tab, never shared with another, gone
 * with the tab.
 */

const KEY = "khazzin.impersonation";

let cached: string | null | undefined;

/** This tab's impersonation token, or null when somebody signed in as themselves. */
export function impersonationToken(): string | null {
	if (cached === undefined) {
		cached = read();
	}
	return cached;
}

/** Forgets the token: the session was ended from its banner. */
export function forgetImpersonation(): void {
	cached = null;
	try {
		window.sessionStorage.removeItem(KEY);
	} catch {
		// Storage refused: the cached null is enough for this page's life.
	}
}

function read(): string | null {
	const match = /(?:^#|&)imp=([^&]+)/.exec(window.location.hash);
	if (match?.[1] !== undefined) {
		const token = decodeURIComponent(match[1]);
		window.history.replaceState(null, "", window.location.pathname + window.location.search);
		try {
			window.sessionStorage.setItem(KEY, token);
		} catch {
			// Storage refused: this page still has it, a reload will not.
		}
		return token;
	}
	try {
		return window.sessionStorage.getItem(KEY);
	} catch {
		return null;
	}
}
